import { productTypesInversed, ProductTypesKeys } from '@teinor/erp/types/company/product'
import { ModalComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { Modify } from '../../../../../../utils/globals/types'
import { InputTableURLsTable } from '../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import ModalUniqueNumberProduct from './ModalUniqueNumberBuyProduct'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { OrderData } from '../../../OrderLayout/types'

export type ModalUniqueNumberProductOrderProps = Modify<ModalComponentProps, {
    onSubmit: () => void
    inputTableURLs: InputTableURLsTable
    completeData: OrderData | null
    allRowData?: RowData
 }>

const ModalUniqueNumberProductOrder: React.FC<ModalUniqueNumberProductOrderProps> = ({...rest}) => {
    const {t} = useTwinTranslation()

    const productType = rest.allRowData?.['productType']
    const isSerialized = productType === productTypesInversed['serialized']
    if (isSerialized){
        return <ModalUniqueNumberProduct title={t('configUniqueNumber', 'Configurador Número de serie')} {...rest} WarehouseId={rest.allRowData?.WarehouseId} productType={productTypesInversed['serialized'] as ProductTypesKeys} />
    }
    return (<ModalUniqueNumberProduct title={t('configLot', 'Configurador Lote')} {...rest} WarehouseId={rest.allRowData?.WarehouseId} productType={productTypesInversed['lots'] as ProductTypesKeys} />)
}


export default ModalUniqueNumberProductOrder